import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const FindingsView = lazy(async () => {
  const m = await import("@/features/findings/components/findings-view");
  return { default: m.FindingsView };
});

export interface FindingsSearch {
  /** Deep-link: pre-select a status filter (e.g. from the dashboard). */
  status?: string;
  /** Deep-link: pre-select a severity filter. */
  severity?: string;
  /** Deep-link: scope findings to a single inspection. */
  inspectionId?: string;
  /** Deep-link: open the finding dialog — `new` to create, an id to edit. */
  finding?: string;
}

export const findingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/findings",
  validateSearch: (search: Record<string, unknown>): FindingsSearch => ({
    status: typeof search.status === "string" ? search.status : undefined,
    severity: typeof search.severity === "string" ? search.severity : undefined,
    inspectionId: typeof search.inspectionId === "string" ? search.inspectionId : undefined,
    finding: typeof search.finding === "string" ? search.finding : undefined,
  }),
  component: () => (
    <Suspense fallback={null}>
      <FindingsView />
    </Suspense>
  ),
});
